export default {
    meta: { title: '关于测试' },
};
